import React from 'react'
import { AppBar, Toolbar, IconButton, Button } from '@mui/material';
import './Navbar.css';
import SIALogo from '../assets/SIALogo.png'
import CanAccess from './access/CanAccess'
import Notification from '../assets/Notification.png'


const MenuBar = ({onSwitchToLogin}) => {
  

  return (
    <div>
        <AppBar position="static">
            <Toolbar className="header-toolbar">
                <IconButton edge="start" color="inherit" aria-label="logo">
                <img src={SIALogo} alt="sia logo" className="logo"/>
                </IconButton>

                <div>
                {/* Removed Get the App button for cleaner header */}
                <Button className="">
                    <img src={Notification} alt="sia notification" />
                </Button>
                <CanAccess component="HOME_LOGIN">
                <Button className="login-button" onClick={onSwitchToLogin}>Login</Button>
                </CanAccess>
                </div>
            </Toolbar>
        </AppBar>
    </div>
  )
}

export default MenuBar